import documentVersionsApi from '@/api/documentVersions';
import api from '@/api';

function initialState() {
  return {
    collection: null,
    single: null,
  };
}

export default {
  namespaced: true,

  state: initialState,

  mutations: {
    setCollection(state, collection) {
      state.collection = collection;
    },

    setSingle(state, single) {
      state.single = Object.assign({}, single);
    },
  },

  actions: {
    list({ commit, state, rootState }) {
      //
    },

    read({ commit, state, rootState }, { documentId, versionId }) {
      const { docType } = rootState.documents;
      commit('setSingle', {});

      documentVersionsApi.read(docType, documentId, versionId)
        .then((docVersion) => {
          commit('setSingle', docVersion);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    /**
     * If we need to update something about a version
     */
    async update({ commit, state, rootState}, {policyId, versionId, payload}) {
      const { docType } = rootState.documents;
      let resp;
      const url = `/${docType.singular}management/${docType.singular}/${policyId}/version/${versionId}`

      try {
        resp = api().post(url,{version: payload, past_date_bypass: true});
        return Promise.resolve(resp)
      } catch(err) {
        return Promise.reject(err);
      }
    }
  },

  getters: {
    //
  },
};
